<template>
  <div class="main-body">
    <div class="header">评估列表</div>
    <div class="out">

      <div class="search2">

        <div style="float:right;">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item :label="value.name+':'" v-for="(value,i) in props.row.listCheckinAssessClassDTO" :key="i" >
                <span>（总得分{{value.sumScore}}）</span>
                <el-button type="text" @click="handleInfo(value.listElderlyCheckinAssessItem)">查看详情</el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
        <el-table-column prop="fraction" label="总分"></el-table-column>
        <!--        <el-table-column prop="checkinAssessLevel" label="护理级别">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span v-if="scope.row.checkinAssessLevel==0 ||scope.row.checkinAssessLevel==null">默认级别</span>-->
        <!--            <span v-if="scope.row.checkinAssessLevel==1">0级（能力完好）</span>-->
        <!--            <span v-if="scope.row.checkinAssessLevel==2">1级（轻度失能）</span>-->
        <!--            <span v-if="scope.row.checkinAssessLevel==3">2级（中度失能）</span>-->
        <!--            <span v-if="scope.row.checkinAssessLevel==4">3级（重度失能）</span>-->
        <!--            <span v-if="scope.row.checkinAssessLevel==5">4级（极重度失能）</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column prop="createTime" :formatter="timefilter" label="创建时间"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></Info>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Info from "../Ins/Info";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalInfo:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_ins:[],
      institutionCode: '',

    }
  },
  components:{
    Info
  },
  created(){
    this.getIns();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },



    handleInfo(value) {
      this.$refs.myInfo.init(value);
      this.showModalInfo = !this.showModalInfo;
    },
    closeInfo:function(){
      this.showModalInfo = !this.showModalInfo;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyCheckinAssess/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {
        //console.log(response);
        this.loading = false;

        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>
<style lang="scss" scoped>

.ElderlyCheckinAssess{
  .demo-table-expand /deep/ label {
    display: inline;
    color: #99a9bf;
  }

  .demo-table-expand /deep/ .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
}
</style>
